export default "/images/developer-options-active-dark.svg?58c00d2660db12b0727dcc143b5e398a";